import { SceneConfig } from "slotworks/config/asset-config-schema";
import DOMLayer from "slotworks/graphics/layers/dom-layer";
import { SceneTransition } from "slotworks/graphics/layers/scene-transitions/scene-transition";
import Contract from "slotworks/utils/contract";
import Rectangle from "slotworks/utils/geom/rectangle";

export default class Scene {
    public positions: Map<string, Rectangle>;
    private transitions: Map<string, SceneTransition> = new Map<string, SceneTransition>();

    private activeTransition: SceneTransition;
    private transitionState: TransitionState;

    constructor(public name: string, public layer: string, public config?: SceneConfig) {
        if (this.config) {
            if (this.config.positions) {
                this.positions = new Map<string, Rectangle>();
                for (const position of this.config.positions) {
                    this.positions.set(position.id, new Rectangle(position.x, position.y, position.width, position.height));
                }                
            }
        }
    }

    // todo
    public reset(config: SceneConfig) {
        if (config) {
            this.config = config;
            if (this.config.positions) {
                this.positions = new Map<string, Rectangle>();
                for (const position of this.config.positions) {
                    this.positions.set(position.id, new Rectangle(position.x, position.y, position.width, position.height));
                }                
            }
        }
    }

    public setTransitions(transitions: SceneTransition, scene: string) {
        this.transitions.set(scene, transitions);
    }

    public in(toScene: string = "*"): Contract<void> {
        let transition: SceneTransition;
        if (this.transitions.has(toScene)) {
            transition = this.transitions.get(toScene);
        } else if (this.transitions.has("*")) {
            transition = this.transitions.get("*");
        }

        if (transition) {
            this.transitionState = TransitionState.IN;
            this.activeTransition = transition;

            return new Contract<void>((resolve) => {
                transition.in().then(() => {
                    this.clearTransitionState();
                    resolve(null);
                });
            });
        }

        return Contract.empty();
    }

    public out(fromScene: string = "*"): Contract<void> {
        let transition: SceneTransition;
        if (this.transitions.has(fromScene)) {
            transition = this.transitions.get(fromScene);
        } else if (this.transitions.has("*")) {
            transition = this.transitions.get("*");
        }

        if (transition) {
            this.transitionState = TransitionState.OUT;
            this.activeTransition = transition;

            return new Contract<void>((resolve) => {
                transition.out().then(() => {
                    this.clearTransitionState();
                    resolve(null);
                });
            });
        }

        return Contract.empty();
    }

    public skipTransition() {
        if (this.transitionState) {
            if (this.transitionState === TransitionState.IN) {
                this.activeTransition.skipIn();
            } else {
                this.activeTransition.skipOut();
            }

            this.clearTransitionState();
        }
    }

    public hasCanvas(): boolean {
        return this.config !== null;
    }

    public hasDOMScene(): boolean {
        return DOMLayer.hasDOMScene(this.name, this.layer);
    }

    public clearDOM() {
        DOMLayer.setDOMScene(this.name, this.layer, false);
    }

    public showDOM() {
        if (this.hasDOMScene()) {
            DOMLayer.setDOMScene(this.name, this.layer, true);
        }
    }

    public destroyTransitions() {
        if (this.activeTransition) {
            this.activeTransition.destroy();
            this.activeTransition = null;
        }
    }

    private clearTransitionState() {
        this.transitionState = null;
    }
}

export enum TransitionState {
    IN = "in",
    OUT = "out"
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/layers/scene.ts